export default __webpack_public_path__ + "static/media/appdev.434c12b0.png";